// Where each security-step type lives, matching the checklist in
// securitySteps.js. A step screen uses this to hand the guest straight to
// whatever is still left instead of stranding them on a finished screen.
const STEP_ROUTES = {
  DOCUMENT: "/documents",
  GUEST_ID: "/id_verify",
  DEPOSIT: "/deposit",
};

const STEP_LABELS = {
  DOCUMENT: "Terms & Agreements",
  GUEST_ID: "ID Verification",
  DEPOSIT: "Damage Protection",
};

/**
 * A Damage Protection step the host covers with Linkbase's integrated damage
 * waiver. The engine creates it already complete — the guest pays nothing
 * and has nothing to do.
 */
export const isHostCoveredDepositStep = (item) =>
  item?.type === "DEPOSIT" &&
  (item.protectionProduct === "integrated_waiver" || item.status === "integrated_waiver");

/**
 * The next security step the guest still has to finish, or null when
 * everything is done. `justCompletedType` is excluded so the step that was
 * just finished on-screen never counts as pending, even before its
 * `isComplete` flag has round-tripped through a refetch.
 */
export const nextIncompleteStep = (booking, justCompletedType) => {
  const items = booking?.securityItems?.items;
  if (!Array.isArray(items)) return null;

  const next = items.find(
    (item) =>
      item.type !== justCompletedType &&
      !item.isComplete &&
      STEP_ROUTES[item.type]
  );

  return next
    ? { type: next.type, path: STEP_ROUTES[next.type], label: STEP_LABELS[next.type] }
    : null;
};
